import DateRangeFilter from '../../../common/date-range-filter/date-range-filter';
import { IDateRangeFilterValue } from '../../../common/date-range-filter/date-range-filter.interface';
import { useHomeStore, useSetHomeStore } from '../../../stores/home-store';

export default function FilterView() {
  const setStore = useSetHomeStore();
  const [fromDate] = useHomeStore(store => store.fromDate);
  const [toDate] = useHomeStore(store => store.toDate);
  const [dateFilterType] = useHomeStore(store => store.dateFilterType);

  return (
    <DateRangeFilter
      idPrefix="home"
      value={{ fromDate, toDate, dateFilterType }}
      onChange={(value: IDateRangeFilterValue) => setStore(value)}
    />
  );
}
